import { configureStore } from "@reduxjs/toolkit";

import profileSlice from "./slices/userProfileDataSlice";
export const store = configureStore({
    reducer: {
      profile: profileSlice
    },
  });